export { default } from "./IconSvg";
